import { io, Socket } from 'socket.io-client';
import { types as mediasoupTypes } from 'mediasoup-client';
import { getCustomLogger } from '../../../../lib/logger';

const logger = getCustomLogger('screenapp:recorder:webrtc:signalling');

export interface MediasoupTransportParams {
  id: string;
  iceParameters: mediasoupTypes.IceParameters;
  iceCandidates: mediasoupTypes.IceCandidate[];
  dtlsParameters: mediasoupTypes.DtlsParameters;
  sctpParameters: mediasoupTypes.SctpParameters;
}

class Signalling {
  private socket: Socket;

  private serverUrl: string;

  constructor(serverUrl = 'http://localhost:3000') {
    this.serverUrl = serverUrl;
  }

  public async connect(): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        this.socket = io(this.serverUrl, { query: { fileId: 'test' } });
        this.socket.on('connect', () => {
          logger.info('Connected to signaling server');
          resolve();
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  public async getRouterCapabilities(): Promise<mediasoupTypes.RtpCapabilities> {
    return new Promise((resolve, reject) => {
      try {
        logger.info('Getting router capabilities');
        this.socket.emit(
          'get-router-capabilities',
          (routerCapabilities: mediasoupTypes.RtpCapabilities) => {
            logger.info('Router capabilities received', routerCapabilities);
            resolve(routerCapabilities);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  public async createTransport(): Promise<MediasoupTransportParams> {
    logger.info('Creating transport');
    return new Promise((resolve, reject) => {
      try {
        this.socket.emit(
          'create-transport',
          (transport: MediasoupTransportParams) => {
            logger.info('Transport created', transport);
            resolve(transport);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  public async connectTransport({
    id,
    dtlsParameters,
  }: {
    id: string;
    dtlsParameters: mediasoupTypes.DtlsParameters;
  }): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        this.socket.emit('connect-transport', { id, dtlsParameters }, () => {
          resolve();
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  public async produce({
    id,
    kind,
    rtpParameters,
    appData,
  }: {
    id: string;
    kind: mediasoupTypes.MediaKind;
    rtpParameters: mediasoupTypes.RtpParameters;
    appData: any;
  }): Promise<{ id: string }> {
    return new Promise((resolve, reject) => {
      try {
        this.socket.emit(
          'produce',
          { id, kind, rtpParameters, appData },
          (response: { id: string }) => {
            resolve(response);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  public close() {
    this.socket.close();
    logger.info('Socket connection closed.');
  }
}

export default Signalling;
